import axios from 'axios';
import AppConfig from '@/app.config';
import { decrypt } from '@/helpers';

console.log(AppConfig);

const instance = axios.create({
  baseURL: AppConfig.API_HOST,
});

instance.interceptors.response.use((response) => {
  if (response.headers['content-type'] === 'application/encrypted+json') {
    // eslint-disable-next-line no-param-reassign
    response.data = decrypt(response.data);
  }
  return response;
}, error => Promise.reject(error));

export default instance;
